var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBeta(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 148.411,
    height: 50,
    viewBox: "0 0 148.411 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "beta",
    transform: "translate(-8892 -9833)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6020",
    "data-name": "Path 6020",
    d: "M25.941-23.326A7.778,7.778,0,0,0,28.783-29.1c0-4.839-2.753-8.3-11.5-8.3H4.18V-7.209H19.057c8.26,0,11.413-3.863,11.413-8.791A7.858,7.858,0,0,0,25.941-23.326ZM17.725-24.88H11.463v-6.3h6.262c2.8,0,4.13.977,4.13,3.019C21.855-25.812,20.878-24.88,17.725-24.88ZM22.61-16.4q0,2.93-4.4,2.93h-6.75V-19.33h6.75C21.1-19.33,22.61-18.619,22.61-16.4Zm15.854-21V-7.209H61.6v-6.749H45.748v-5.195H58.982v-6.3H45.748v-5.195H61.6V-37.4Zm58.932,0H68.619v6.749h10.7V-7.209h7.372V-30.651H97.4ZM123.51-7.209h7.772L118.314-37.4h-8.127L97.263-7.209h7.727l2-4.706h14.566ZM109.521-17.865l4.8-11.277,4.707,11.277Z",
    transform: "translate(8898.475 9880.305)",
    fill: "#ee0616"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1288",
    "data-name": "Rectangle 1288",
    d: "M6.524-3H135.888a9.535,9.535,0,0,1,9.524,9.524V37.476A9.535,9.535,0,0,1,135.888,47H6.524A9.535,9.535,0,0,1-3,37.476V6.524A9.535,9.535,0,0,1,6.524-3ZM135.888,42.238a4.767,4.767,0,0,0,4.762-4.762V6.524a4.767,4.767,0,0,0-4.762-4.762H6.524A4.767,4.767,0,0,0,1.762,6.524V37.476a4.767,4.767,0,0,0,4.762,4.762Z",
    transform: "translate(8895 9836)",
    fill: "#ee0616"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeta);
export default __webpack_public_path__ + "static/media/beta.3cee86e9.svg";
export { ForwardRef as ReactComponent };